import React from 'react';
import { Box } from '@rsos/components/capstone/base';
import {
  AccordionSectionDesc,
  AccordionSectionTitle,
} from '../../../CustomAccordion.styles';

const EmptyCarHeader = ({ data }) => {
  const { railcar_sequence, equipment_id } = data;
  return (
    <Box flow={5}>
      <AccordionSectionTitle>
        CAR {railcar_sequence} - {equipment_id}
      </AccordionSectionTitle>
      <AccordionSectionDesc>Empty</AccordionSectionDesc>
    </Box>
  );
};

export default EmptyCarHeader;
